import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  height: 100%;
  width: 100%;
  position: absolute;
`;

export const Drawer = styled.div`
  z-index:  ${(props) => props.zIndex};
  position: fixed;
  width: ${(props) => props.drawerWidth || '100%'};
  height: 100%;
  top: ${(props) => props.positionFromTop || '60px'};
  ${(props) => props.positionFromRight && `
    right: ${props.positionFromRight}px;
    z-index:  ${(props) => props.zIndex === "1" ? "1024" : "1200"};
  `}
  ${(props) => props.positionFromLeft && `
    width: calc(100% - ${props.positionFromLeft}px);
    left: ${props.positionFromLeft}px;
  `}
`;

export const ModalArea = styled.div`
  position: ${(props) => props.positionFromRight ? 'fixed' : 'inherit'};
  height: 100%;
  width: ${(props) => props.drawerWidth || '70%'};
  max-width: 1030px;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  grid-column: 1;
  grid-row: 1;
  z-index:  ${(props) => props.zIndex};
  overflow-y: scroll;
  overflow-x: hidden;

  background-color: ${(props) => props.theme['color.background']};
  ${(props) => props.lightBackground && props.theme.themeId !== 'dark' && `
    background-color: ${props.theme[props.lightBackground]};
  `}

  ${(props) => props.positionFromRight && `
    right: ${props.positionFromRight}px;
    box-shadow: -1px 0 4px 0 rgba(0,0,0,0.15);
  `}

  ${(props) => (props.status !== 'entered') && `
    transform: translate3d(${props.positionFromRight ? 100 : -100}%, 0, 0);
  `}
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: 0;
  background-color: #000000;
  transition: all 0.4s ease;
  opacity: ${(props) => props.status === 'entered' ? 0.5 : 0};
  grid-column: 1;
  grid-row: 1;
`;
